// Notice SAV B2C publique, servie par Symfony (App\Controller\NoticeController,
// slug « sav ») : l'URL de base est celle du BO Symfony (commande.lemoulin.fr),
// pas celle de moulin-admin (REACT_APP_LEMOULIN_URL = admin.lemoulin.fr).
export const SAV_NOTICE_URL = `${process.env.REACT_APP_LEMOULIN_BO_URL}/notice/sav`;
